import { render, staticRenderFns } from "./JaliscoDoughutCharComponent.vue?vue&type=template&id=44190843&scoped=true"
import script from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
export * from "./JaliscoDoughutCharComponent.vue?vue&type=script&lang=js"
import style0 from "./JaliscoDoughutCharComponent.vue?vue&type=style&index=0&id=44190843&prod&scoped=true&lang=css"
import style1 from "@/other/assets/css/app.css?vue&type=style&index=1&id=44190843&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44190843",
  null
  
)

export default component.exports